import { HttpLink, split, ApolloClient, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';

// Create an HTTP link for queries/mutations
const httpLink = new HttpLink(
  { uri: process.env.REACT_APP_API_HTTP_URL, credentials: 'include' }
);

// Create a WebSocket link for subscriptions using graphql-ws
const wsLink = new GraphQLWsLink(
  createClient({ url: process.env.REACT_APP_API_WS_URL })
);

// Use split to route queries/mutations to httpLink and subscriptions to wsLink
const splitLink = split(
  ({ query }) => {
    const mainDef = getMainDefinition(query);
    return (
      mainDef.kind === 'OperationDefinition' &&
      mainDef.operation === 'subscription'
    );
  },
  wsLink,
  httpLink
);

// Handle imageSrc computation for fields implementing the Image interface

function regularBase64ToUrlSafeBase64(regularBase64) {
  return regularBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '*');
}

const cache = new InMemoryCache({
  typePolicies: {
    PlainImage: {
      fields: {
        imageSrc: {
          read(_, { readField }) {
            const url       = encodeURIComponent(readField('url'));
            const mimeType  = regularBase64ToUrlSafeBase64(readField('mimeType'));

            return `/image?encoding=PlainImage&mimeType=${mimeType}&url=${url}`
          },
        },
      },
    },
    EncryptedImageV1: {
      fields: {
        imageSrc: {
          read(_, { readField }) {
            const url       = encodeURIComponent(readField('url'));
            const key       = regularBase64ToUrlSafeBase64(readField('key'));
            const iv        = regularBase64ToUrlSafeBase64(readField('iv'));
            const imageSize = parseInt(readField('imageSize'), 10);
            const mimeType  = regularBase64ToUrlSafeBase64(readField('mimeType'));

            return `/image?encoding=EncryptedImageV1&url=${url}&key=${key}&iv=${iv}&imageSize=${imageSize}&mimeType=${mimeType}`;
          },
        },
      },
    },
  },
});


// Create the Apollo Client
const apolloClient = new ApolloClient({ link: splitLink, cache, credentials: 'include' });

export default apolloClient;